<template>
  <div id="display_none" style="width: 100%;">
    <div class="operation-wrap" v-if="(status!='COPYTO' && status!='FOLLOW' && (type!=undefined || taskId!=undefined)) && 
    opinionMap[selectNodeId] && opinionMap[selectNodeId].revoke && opinionMap[selectNodeId].opinionstatus!='transAgree' 
    && opinionMap[selectNodeId].opinionstatus!='opposeTrans' && instStatus != 'end'">
      <div class="btn_region" :style="'height:'+btn_region_h+';width:100%'"   
     ref="btnRegion">
      <div class="btn_region_in" :style="'width:' +btn_region_in_w">
        <br>
        <div class="action-container">
            <span>操作区域</span>
        </div>
        <div>
            <table style="width:100%;">
              <tbody>
                <!-- <tr>
                    <td class="action-group action-btn">
                      <el-radio v-for="op in opinionList" :key="op.taskkey" v-model="selectNodeId" :label="op.taskkey">{{op.taskname}}</el-radio>
                    </td>
                </tr> -->
                <tr>
                  <!-- <td></td> -->
                    <td class="action-group action-btn">
                      <el-button type="danger" @click="handleRevoke" size="small" :disabled="disabled">撤 回</el-button>
                      <!-- <el-button type="default" @click="taskClose">关闭</el-button> -->
                    </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
    <el-dialog title="撤回" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="28%">
        <el-container v-if="taskSignLines.length>0" >
            <el-header style="text-align: left; font-size: 12px">
              <span>从以下人员中撤回工作项</span>
            </el-header>
            <el-main>
              <el-checkbox-group v-model="inApprovalTaskIds">
								<span v-for="taskSign in taskSignLines" :key="taskSign.taskid">
									<el-checkbox :label="taskSign.taskid" :disabled="!(taskSign.status=='approval' || taskSign.status=='withdrawApproval') || taskSign.isRead  ">{{taskSign.executor | executorFormat }}</el-checkbox>
									<br/>
								</span>
							</el-checkbox-group>
            </el-main>
          </el-container>
          <div v-else>
            <h1>是否撤回？</h1>
          </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRevoke" size="small">确 定</el-button>
          <el-button @click="exitRevoke" size="small">取 消</el-button>
        </div>
    </el-dialog>

    <DoneFormContent ref="doneFormContent" v-if="opinionMap[selectNodeId]" :instId="instId" 
      :nodeId="selectNodeId" :taskId="opinionMap[selectNodeId].taskid" :workOrderNo = "workOrderNo"
      :pData="opinionMap[selectNodeId].formdata" :isProcessRecord.sync="isProcessRecord" :isShowOperateArea="isShowOperateArea"/>

    <!-- <ProcessRecord :instId="instId"  v-show="isProcessRecord"/> -->
    <!-- 流程图 -->
    <!-- <ImageBpm :instId="instId"/> -->
  </div>
</template>
<script>
import ProcessRecord from "@/components/flow/processRecord.vue";
import ImageBpm from "@/components/flow/imageBpm.vue";
import DoneFormContent from "@/components/flow/doneFormContent.vue";
import OpinionText from "@/components/common/opinionText.vue";
import FileUpload from "@/components/common/fileUpload.vue";
import { mapState } from "vuex";
import { Message } from "element-ui";
import TaskToReject from "@/components/flow/task/taskToReject.vue";
import TaskToDelegate from "@/components/flow/task/taskToDelegate.vue";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";
import TaskToInqu from "@/components/flow/task/taskToInqu.vue";
import TaskToEndProcess from "@/components/flow/task/taskToEndProcess.vue";
import utils from "@/utils.js";
import { Base64 } from "js-base64";
import req from "@/request.js";

export default {
  components: {
    ImageBpm,
    ProcessRecord,
    DoneFormContent,
    OpinionText,
    FileUpload,
    TaskToReject,
    TaskToDelegate,
    TaskToCopyTo,
    TaskToInqu,
    TaskToEndProcess,
  },
  props: [
    "instId",
    "type",
    "taskId",
    "defId",
    "status",
    "choiceExcutor",
    "jumpType",
    "instStatus",
    "leaderId",
    "workOrderNo" //工单号
  ],
  data() {
    return {
      btn_region_t:"28px",
      btn_region_in_w:"100%",
      btn_region_h:"102px",
      btn_region_w:"",
      dialogFormVisible: false,
      dailogTitle: "",
      opinion: "撤回",
      isHand: "",
      state: "",
      canLock: "",
      formData: "",
      actionName: "",
      text: "",
      disabled: false,
      btnAilas:"",//选择的按钮
      token:utils.getUrlKey("token"),
      opinionMap:{},
      opinionList:[],
      selectNodeId:'',
			inApprovalTaskIds:[],
      taskSignLines:[],
      isProcessRecord:true,
    };
  },
  watch: {
  },
  
   computed:{
    ...mapState('storeProcess',['rowsBtn']),
   isShowOperateArea(){
     return (this.status!='COPYTO' && this.status!='FOLLOW' && (this.type!=undefined || this.taskId!=undefined)) && 
    this.opinionMap[this.selectNodeId] && this.opinionMap[this.selectNodeId].revoke && this.opinionMap[this.selectNodeId].opinionstatus!='transAgree' 
    && this.opinionMap[this.selectNodeId].opinionstatus!='opposeTrans' && this.instStatus != 'end'
   }
  },
  mounted(){
    window.jQuery("#app").find("#hymenu").css("width","0px;");
    window.jQuery("#app").find("#hycontent").css({"width":"100%","height":"100%"});

    //单选操作按钮默认选择第一个
    if(this.rowsBtn.length>0  && this.canLock!=1){
      this.btnAilas=this.rowsBtn[0].alias;
    }else if(this.rowsBtn.length==0 && this.canLock!=1){
        if(this.type=='done' || this.type=='request'){
          this.btnAilas="handleRevoke";
        }else if(this.type=='read'){
          this.btnAilas="handleRead";
        }
    }
  },
  methods: {
    //关闭按钮
    taskClose(){
      /*if (JSON.stringify(this.$route.query) == "{}") {
        this.$router.go("-1");
      } else {
        this.$router.push("/home");
      }*/
        window.close();
    },
    //获取当前任务节点
    getSelectNodeId(){
      return this.selectNodeId;
    },
      //撤回到上一个节点
    handleRevoke(){
			let curOpinion = this.opinionMap[this.selectNodeId];
			if(curOpinion.needgetrevoketasks){
				let data = {instanceId:this.instId,"nodeId":curOpinion.taskkey,"taskId":curOpinion.taskid};
				this.$store.dispatch("storeProcess/getSignLinesInstIdNodeId",data).then((data)=>{
					this.taskSignLines = data;
          this.dialogFormVisible=true;
        }).catch(()=>{
          this.dialogFormVisible=false;
        });
			}else{
        this.dialogFormVisible=true;
      }
    },
    saveRevoke(){

      let curOpinion = this.opinionMap[this.selectNodeId];
      let data ={instanceId:this.instId,cause:this.opinion,taskId:curOpinion.taskid,revokeNodeId:this.selectNodeId};
      //用户任务1,直接使用撤回到发起人的逻辑
      if(!curOpinion.revokestart){
        data.isHandRevoke = true;
      }else{
        data.isHandRevoke = false;
      }
      //正常撤回
      let revokeUrl = "storeProcess/revokeInstance";
      // 签署撤回
      if(curOpinion.signtype && curOpinion.signtype != "AfterSign"  ){
          revokeUrl = "storeProcess/revokeCustomSign";
          data ={currentTaskIds:this.inApprovalTaskIds.join(","),instanceId:this.instId,cause:this.opinion,targetTaskId:curOpinion.taskid,targetNodeId:this.selectNodeId,signType:curOpinion.signtype};
      }

      this.$store.dispatch(revokeUrl,data).then(value=>{
        this.dialogFormVisible=false;
        this.opinion="";
        if(window.ch){
          //浏览器的两个选项卡之间通讯 新窗口发送消息
          window.ch.postMessage("some data");
        }
        window.close();
        // this.reload();
        // if(this.token!=null){
        //     window.close();
        // }else{
        //   this.$router.go(-1);
        // }
      });
    },
    exitRevoke(){
      this.dialogFormVisible=false;
      this.opinion="";
    },
    hiddenOpertion() {
      if(this.$refs.btnRegion){
        this.$refs.btnRegion.style.display = "none";
      }
      this.$refs.doneFormContent.hiddenContent();
    }
  },
  created() {
    //兼容只显示审批页面时
    if(this.$route.meta.single){
      this.btn_region_t="48px";
      this.btn_region_in_w="100%";
    }
    const loading = this.$loading({
      lock: true,
      text: '表单加载中......',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let queryFilter = {};
    let pageBean = {"pageBean":this.pagination};
    let querys = [{property: "wfInst.id_", value: this.instId, group: "typeId", operation: "IN", relation: "AND"},];
    queryFilter = {"pageBean":this.pagination,querys};
    let _this = this;
    this.$store.dispatch("storeProcess/getDoneByInstId",queryFilter).then((data)=>{
        if (data.data && data.data.rows) {
          data.data.rows.forEach(opinion => {
            if( opinion.opinionstatus != 'signRecoverCancel' && opinion.opinionstatus != 'retracted' && opinion.opinionstatus != 'start' && opinion.opinionstatus !='end' &&
               !_this.opinionMap[opinion.taskkey] && opinion.opinionstatus !='awaiting_check' && opinion.opinionstatus !='copyto'
               && opinion.opinionstatus !='copyto_reply'  && opinion.opinionstatus !="start_commu"){
              if(opinion.opinionstatus =='skip' && opinion.skiptype != 'first'){
                return true;
              }
              if(opinion.formdata){
                 opinion.formdata = JSON.parse(Base64.decode(opinion.formdata));
              }
              _this.opinionMap[opinion.taskkey] = opinion;
              _this.opinionList.push(opinion);
              _this.selectNodeId = _this.opinionList[0].taskkey;
              _this.$forceUpdate();
              if(!(_this.opinionMap[_this.selectNodeId] && _this.opinionMap[_this.selectNodeId].revoke && _this.opinionMap[_this.selectNodeId].opinionstatus!='transAgree' 
                && _this.opinionMap[_this.selectNodeId].opinionstatus!='opposeTrans' && _this.instStatus != 'end')){
                  _this.hiddenOpertion();
                }
              setTimeout(()=>{
                _this.$set(_this,"btn_region_w",document.getElementById("display_none").offsetWidth);
              },1500)
            }
          });
          loading.close();
        }else{
          loading.close();
        }
    }).catch(() => {
      loading.close();
    });
  },
	filters:{
		executorFormat:function(value){
			return value.name + "  " + value.account+"  " + value.orgName;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.operation-wrap{
  height: 102px;
}
.action-container {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
  padding-left: 20px;
}

.action-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

.action-content {
  padding: 20px 0;
}

.action-group {
  padding-top: 10px;
}

.action-btn {
  float: left;
  padding-right: 5px;
  padding-left: 20px;
}
.btn_region{
  position: fixed;
  z-index: 100;
  background:#f5f5f5;
}
.btn_region_in{
  margin: 0 auto;
  // background-color: #fff;
}
.region{
  padding-top: 10px;
}
.el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 30px;
		height: 30px!important;
		margin-top: -40px;
  }
</style>
